<template>
	<section v-if="props">
		<carousel :navigationEnabled="true" :navigationNextLabel="''" :navigationPrevLabel="''" :perPage="1" :paginationActiveColor="'#f58466'" :paginationColor="'#dedede'" :navigationClickTargetSize="5" :paginationPadding="5" :paginationSize="14" v-in-viewport="{}">
			<template class="image-slider" v-if="props.video_slider" v-for="(slide,i) in props.video_slider">
				<slide v-if="(slide.image.value.length)" :style="setBackgroundImage(slide.image.value[0].url)" @slideClick="handleSlideClick" :data-name="slide.vimeo_id.value" :data-videoID="'video_'+i" class="VueCarousel-video image-container">
					<div class="play-button" :data-video-id="slide.vimeo_id.value" style="display: block;"></div>
					<div :id="'video_'+i" class="embed-container"></div>
				</slide>
				<slide class="video-container" v-else>
					<div class="embed-container">
						<iframe :src="'https://player.vimeo.com/video/'+slide.vimeo_id.value+'?loop=1&title=0&byline=0&portrait=0&api=1'" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
					</div>
				</slide>
			</template>

			<template class="image-slider" v-if="props.slider_images.value.length" v-for="slide in props.slider_images.value">
				<slide class="image-container">
					<div :style="setBackgroundImage(slide.url)" class="bg-inside">	
						<img :src="slide.url" :alt="slide.name">
					</div>
				</slide>
			</template>
		</carousel>
	</section>
</template>


<script>
  require('../assets/img/left.svg');
	require('../assets/img/right.svg');
	require('../assets/img/play-button-circle.png');

	import { Carousel, Slide } from 'vue-carousel';
	import commons from '../mixins/common.js';
	import Player from '@vimeo/player';

	export default{
		name:'Porfolio',
		props: ['props'],
		mixins:[commons],
		components:{
			Carousel,
			Slide
		},
		data(){
			return{

			}
		},
		methods: {

			handleSlideClick: function(dataset) {
				setTimeout(function(){
					let v = dataset.videoid;
					$('.play-button[data-video-id='+dataset.name+']').hide();
					const player = new Player(document.getElementById(v), {
				    id: dataset.name,
				    width: 640,
						autoplay: true
					});

				},200);
			},
		},

		mounted () {
			setTimeout(function(){


					$('.VueCarousel-dot-button,.VueCarousel-navigation-button').on('click', function(){
						$('iframe').each(function() {
						  this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
						  this.contentWindow.postMessage('{"method":"pause","value":""}', '*');
						});
					})

			},200);

		}
	}
</script>



// WEBPACK FOOTER //
// porfolio.vue?07a614dd